import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  Text,
  Flex,
  Link,
  VStack,
} from '@chakra-ui/react';
import Button from 'common/components/button';
import { useState } from 'react';

const MonthlyRentHelperModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size='xl'>
      <ModalOverlay />
      <ModalContent className='rounded-lg'>
        <ModalHeader className='text-xl font-medium border-b border-gray-200'>
          Base Rent vs. Total Monthly Payment
        </ModalHeader>
        <ModalBody className='pt-4 pb-6'>
          <VStack className='gap-4 text-gray-500'>
            <Text className='text-base'>
              Your rental agreement may include monthly charges like internet, utilities, landlord liability insurance, etc. These are fixed charges that may be difficult or impossible to cancel in the event of an early lease termination. 
            </Text>
            
            <VStack className='gap-3 w-full text-left'>
              <Text className='text-base'>
                <Text as='span' className='font-semibold text-gray-700'>Option 1: Total Monthly Payment (Recommended)</Text> - Use your total monthly payment (base rent + fixed charges). Choose this if you want ReLease to cover all fixed monthly charges in the event of an early move out.
              </Text>
              
              <Text className='text-base'>
                <Text as='span' className='font-semibold text-gray-700'>Option 2: Base Rent Only</Text> - Use your base rent amount. Choose this if you believe additional charges can be canceled if your lease is terminated early, or you don't want these charges covered.
              </Text>
            </VStack>
          </VStack>
        </ModalBody>
        <ModalFooter className='border-t border-gray-200'>
          <ButtonGroup>
            <Button title='I Understand' onClick={onClose} wFull={false} />
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const MonthlyRentHelperLink = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Link
        onClick={() => setIsOpen(true)}
        className='underline cursor-pointer'
      >
        {children || 'Not sure what number to put?'}
      </Link>
      <MonthlyRentHelperModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export { MonthlyRentHelperModal, MonthlyRentHelperLink }; 